var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminExit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_3953",
    "data-name": "\\uADF8\\uB8F9 3953",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1756",
    "data-name": "\\uC0AC\\uAC01\\uD615 1756",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3487",
    "data-name": "\\uADF8\\uB8F9 3487",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_24",
    "data-name": "\\uD328\\uC2A4 24",
    d: "M5783.732,9593.578l16-16",
    transform: "translate(-5783.732 -9577.578)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_25",
    "data-name": "\\uD328\\uC2A4 25",
    d: "M0,16,16,0",
    transform: "translate(15.999) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminExit);
export default __webpack_public_path__ + "static/media/admin_exit.6f67a4febae3041a6d39f5572ac8f965.svg";
export { ForwardRef as ReactComponent };